module.exports = __webpack_public_path__ + "img/close-round.afb193b5.svg";